import Box from "@mui/material/Box";
import type { ReactNode } from "react";

export interface AuthShellProps {
  brandPanel?: ReactNode;
  children: ReactNode;
}

/**
 * Full-height split layout: brand panel on the left, form content on the
 * right. When a brand panel is given, the brand gradient covers the *whole*
 * page (both halves) rather than just the left strip, so the form side
 * doesn't read as a mismatched plain-white panel next to it - the form card
 * itself provides the light/dark contrast instead.
 */
export function AuthShell({ brandPanel, children }: AuthShellProps) {
  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        ...(brandPanel
          ? { background: "linear-gradient(135deg, #2f2a27 0%, #3F3834 45%, #5386A3 100%)" }
          : {}),
      }}
    >
      {brandPanel}
      <Box
        sx={{
          display: "flex",
          flexGrow: 1,
          alignItems: "center",
          justifyContent: "center",
          p: { xs: 2, sm: 4 },
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
